import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --app-primary: ${({ theme }) => theme.colors.primary};
    --app-primary-dark: ${({ theme }) => theme.colors.primaryDark};
    --app-bg: ${({ theme }) => theme.colors.background};
    --app-paper: ${({ theme }) => theme.colors.paper};
    --app-text: ${({ theme }) => theme.colors.text};
    --app-text-secondary: ${({ theme }) => theme.colors.textSecondary};
    --app-border: ${({ theme }) => theme.colors.border};
    --app-radius: ${({ theme }) => theme.radius.lg};
  }
  *, *::before, *::after { box-sizing: border-box; }
  body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
    line-height: 1.5;
  }
  button, input, textarea, select { font: inherit; }
  input:not([type='checkbox']):not([type='radio']):not([type='color']):not([type='file']), textarea, select {
    min-height: 42px;
    border-color: ${({ theme }) => theme.colors.borderStrong} !important;
    border-radius: ${({ theme }) => theme.radius.md} !important;
    background-color: ${({ theme }) => theme.colors.paper};
    color: ${({ theme }) => theme.colors.text};
    transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
  }
  input::placeholder, textarea::placeholder { color: ${({ theme }) => theme.colors.textMuted}; opacity: 1; }
  input:focus-visible, textarea:focus-visible, select:focus-visible, button:focus-visible, a:focus-visible {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary} !important;
    box-shadow: ${({ theme }) => theme.shadows.focus};
  }
  label { color: ${({ theme }) => theme.colors.label}; font-size: 13px; font-weight: 600; }
  button { transition: color 160ms ease, background 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease; }
  button:not(:disabled):active { transform: translateY(1px); }
  button:disabled { cursor: not-allowed; opacity: .55; }
  table { border-spacing: 0; }
  thead th {
    height: 44px;
    border-color: ${({ theme }) => theme.colors.border} !important;
    background: ${({ theme }) => theme.colors.neutral} !important;
    color: ${({ theme }) => theme.colors.textSecondary};
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .02em;
  }
  tbody td {
    height: 48px;
    border-color: ${({ theme }) => theme.colors.border} !important;
    color: ${({ theme }) => theme.colors.text};
  }
  tbody tr { transition: background 150ms ease; }
  tbody tr:hover { background: #F8FAFC; }

  .swal2-popup {
    border-radius: ${({ theme }) => theme.radius.xl};
    box-shadow: ${({ theme }) => theme.shadows.md};
  }
  .swal2-title { color: ${({ theme }) => theme.colors.text}; font-size: 22px; }
  .swal2-html-container { color: ${({ theme }) => theme.colors.textSecondary}; }
  .swal2-confirm { border-radius: ${({ theme }) => theme.radius.md} !important; background: ${({ theme }) => theme.colors.primary} !important; }
  .swal2-cancel { border-radius: ${({ theme }) => theme.radius.md} !important; }
  ::selection { color: #fff; background: ${({ theme }) => theme.colors.primary}; }
  * { scrollbar-width: thin; scrollbar-color: #CBD5E1 transparent; }
  *::-webkit-scrollbar { width: 8px; height: 8px; }
  *::-webkit-scrollbar-track { background: transparent; }
  *::-webkit-scrollbar-thumb { background: #CBD5E1; border: 2px solid transparent; border-radius: 999px; background-clip: padding-box; }
  *::-webkit-scrollbar-thumb:hover { background: #94A3B8; background-clip: padding-box; }

  /* Shell administrativo inspirado no padrão visual do Negoxio. */
  body {
    background:
      radial-gradient(circle at top right, rgba(37, 99, 235, .10), transparent 34%),
      linear-gradient(135deg, #eef4ff 0%, #f8fbff 48%, #edf6f2 100%);
  }

  body .bo-admin-page.bo-admin-page {
    --bo-sidebar-width: 288px;
    display: grid !important;
    grid-template-columns: var(--bo-sidebar-width) minmax(0, 1fr);
    align-items: stretch;
    width: 100% !important;
    height: 100dvh !important;
    min-height: 100dvh;
    margin: 0;
    background: transparent;
  }

  body .bo-admin-page.bo-admin-page:has(.bo-admin-sidebar-slot[data-isopen='false']) {
    grid-template-columns: 0 minmax(0, 1fr);
  }

  body .bo-admin-page .bo-admin-sidebar-slot {
    width: var(--bo-sidebar-width) !important;
    height: 100dvh !important;
    min-height: 0;
    overflow: hidden;
    border: 0;
    background: #0d2348;
    transition: width 220ms ease;
  }

  body .bo-admin-page .bo-admin-sidebar-slot[data-isopen='false'] {
    width: 0 !important;
  }

  body .bo-admin-page .bo-sidebar {
    display: flex;
    min-width: var(--bo-sidebar-width);
    height: 100%;
    padding: 18px 16px 20px;
    gap: 16px;
    color: #fff;
    background: linear-gradient(180deg, #102d59 0%, #091c3c 100%);
  }

  body .bo-admin-page .bo-sidebar-brand {
    display: flex;
    justify-content: flex-start;
    min-height: 70px;
    padding: 0 8px;
    border: 0;
    background: transparent;
  }

  body .bo-admin-page .bo-sidebar-brand img {
    width: 210px;
    height: 58px;
    padding: 0;
    filter: brightness(0) invert(1);
    object-fit: contain;
  }

  body .bo-admin-page .bo-sidebar-menu {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    gap: 10px;
    padding: 14px 10px;
    overflow-y: auto;
    border: 1px solid rgba(255, 255, 255, .10);
    border-radius: 22px;
    background: rgba(255, 255, 255, .055);
  }

  body .bo-admin-page .bo-sidebar-menu > p {
    margin: 2px 10px 6px;
    color: rgba(255, 255, 255, .62);
  }

  body .bo-admin-page .bo-sidebar-menu ul {
    display: grid;
    gap: 6px;
    align-items: stretch;
  }

  body .bo-admin-page .bo-sidebar-menu li {
    width: 100%;
    min-height: 44px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 14px;
    color: #fff;
    background: transparent;
  }

  body .bo-admin-page .bo-sidebar-menu li:hover,
  body .bo-admin-page .bo-sidebar-menu li[data-active='true'] {
    border-color: rgba(255, 255, 255, .10);
    background: rgba(255, 255, 255, .16);
  }

  body .bo-admin-page .bo-sidebar-menu a {
    min-height: 44px;
    padding: 0 14px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
  }

  body .bo-admin-page .bo-sidebar-menu a svg {
    color: rgba(255, 255, 255, .72);
  }

  body .bo-admin-page .bo-sidebar-menu li[data-active='true'] a,
  body .bo-admin-page .bo-sidebar-menu li[data-active='true'] a svg {
    color: #fff;
  }

  body .bo-admin-page .bo-sidebar-profile {
    height: auto;
    min-height: 74px;
    padding: 0;
    color: #fff;
  }

  body .bo-admin-page .bo-sidebar-profile > div:first-child {
    width: 100%;
    height: auto;
    padding: 10px 12px;
    border: 1px solid rgba(255, 255, 255, .10);
    border-radius: 20px;
    background: rgba(255, 255, 255, .065);
  }

  body .bo-admin-page .bo-sidebar-profile img {
    border-color: rgba(255, 255, 255, .40);
  }

  body .bo-admin-page .bo-sidebar-profile span,
  body .bo-admin-page .bo-sidebar-profile div {
    color: inherit;
  }

  body .bo-admin-page .bo-sidebar-profile button,
  body .bo-admin-page .bo-sidebar-profile a {
    color: #fff;
  }

  body .bo-admin-page .bo-admin-content {
    min-width: 0;
    min-height: 0;
    height: 100dvh !important;
    background: transparent;
  }

  body .bo-admin-page .bo-admin-header-slot {
    flex: 0 0 auto;
    min-height: 90px !important;
    height: 90px;
    padding: 18px 24px 0;
    border: 0;
    background: transparent;
  }

  body .bo-admin-page .bo-admin-header-card {
    min-height: 70px;
    height: 72px;
    padding: 0 24px;
    border: 1px solid rgba(206, 222, 255, .92);
    border-radius: 26px;
    background: rgba(255, 255, 255, .88);
    box-shadow: 0 10px 28px rgba(30, 61, 103, .06);
  }

  body .bo-admin-page .bo-admin-header-card .bo-admin-header-card,
  body .bo-admin-page .bo-admin-header-card button {
    color: var(--app-text);
  }

  body .bo-admin-page .bo-admin-header-card .bo-admin-header-card button,
  body .bo-admin-page .bo-admin-header-card > div:first-child button {
    border: 1px solid #cfe0ff;
    border-radius: 14px;
    background: #fff;
  }

  body .bo-admin-page .bo-admin-header-card .bo-admin-header-card button:hover,
  body .bo-admin-page .bo-admin-header-card > div:first-child button:hover {
    background: #eff6ff;
  }

  body .bo-admin-page .bo-admin-main {
    min-height: 0;
    height: auto !important;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 20px 24px 24px;
    overflow: auto;
    box-sizing: border-box;
    background: transparent;
  }

  body .bo-admin-page .bo-page-toolbar {
    display: flex;
    flex: 0 0 auto;
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    min-height: 64px;
    padding: 0 0 18px;
    background: transparent;
  }

  body .bo-admin-page .bo-page-toolbar input {
    flex: 1;
    width: auto;
    max-width: none;
    min-width: 180px;
    height: 48px;
    padding: 0 16px;
    border: 1px solid #cfe0ff;
    border-radius: 15px;
    background-color: rgba(255, 255, 255, .92);
  }

  body .bo-admin-page .bo-page-toolbar button {
    min-height: 48px;
    padding: 0 20px;
    border: 0;
    border-radius: 15px;
    color: #fff;
    background: linear-gradient(135deg, #0b5fff, #08a7bf);
    box-shadow: 0 10px 22px rgba(11, 95, 255, .16);
    font-size: 14px;
    font-weight: 800;
    white-space: nowrap;
  }

  body .bo-admin-page .bo-page-toolbar button:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  body .bo-admin-page .bo-page-content {
    flex: 1;
    min-height: 0;
    height: auto !important;
    padding: 0;
    position: relative;
  }

  body .bo-admin-page .bo-admin-main > .bo-page-content,
  body .bo-admin-page .bo-admin-main > .bo-page-content > div {
    min-height: 0;
  }

  body .bo-admin-page .bo-dashboard-kpis {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 14px;
    margin: 0 0 18px;
  }

  body .bo-admin-page .bo-dashboard-kpis > div {
    min-width: 0;
    min-height: 132px;
    padding: 20px;
    border: 1px solid #dce6f3;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 61, 103, .06);
  }

  body .bo-admin-page .bo-dashboard-charts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    min-height: 260px;
    margin-bottom: 14px;
  }

  body .bo-admin-page .bo-dashboard-chart-wide {
    grid-template-columns: minmax(0, 1fr);
    min-height: 330px;
  }

  body .bo-admin-page .bo-dashboard-charts > div {
    min-width: 0;
    overflow: hidden;
    border: 1px solid #dce6f3;
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 61, 103, .05);
  }

  body .bo-admin-page .data-card-list {
    position: relative;
    inset: auto;
    display: flex;
    min-height: 0;
    height: 100%;
    padding: 24px 30px 0;
    border: 1px solid rgba(206, 222, 255, .92);
    border-radius: 24px;
    background: rgba(255, 255, 255, .88);
    box-shadow: 0 12px 30px rgba(30, 61, 103, .05);
  }

  body .bo-admin-page .data-card-list > div:first-child {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: auto;
  }

  body .bo-admin-page .data-card-list table {
    width: 100%;
    min-width: 0;
    border-spacing: 0 12px !important;
  }

  body .bo-admin-page .data-card-list thead {
    display: none;
  }

  body .bo-admin-page .data-card-list tbody {
    display: grid;
    align-content: start;
    grid-auto-rows: max-content;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  body .bo-admin-page .data-card-list tbody tr {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-content: start;
    gap: 5px 12px;
    min-height: 0;
    height: max-content;
    padding: 12px 14px;
    border: 1px solid #dce6f3;
    border-radius: 17px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 61, 103, .06);
    filter: none;
    white-space: normal;
    transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
  }

  body .bo-admin-page .data-card-list tbody tr:hover {
    border-color: #b8d0ff;
    box-shadow: 0 12px 24px rgba(30, 61, 103, .10);
    transform: translateY(-1px);
  }

  body .bo-admin-page .data-card-list tbody tr:has(td[colspan]) {
    display: block;
    grid-column: 1 / -1;
    min-height: 120px;
  }

  body .bo-admin-page .data-card-list tbody td,
  body .bo-admin-page .data-card-list tbody td:first-child,
  body .bo-admin-page .data-card-list tbody td:last-child {
    display: block;
    min-width: 0;
    padding: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    color: #334155;
    white-space: normal;
    vertical-align: middle;
  }

  body .bo-admin-page .data-card-list tbody td:last-child {
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
    align-self: center;
  }

  body .bo-admin-page .data-card-list tbody td:first-child {
    color: #71809a;
    font-size: 11px;
    font-weight: 800;
  }

  body .bo-admin-page .data-card-list tbody td[data-label]::before {
    display: block;
    margin-bottom: 2px;
    color: #94a3b8;
    content: attr(data-label);
    font-size: 8px;
    font-weight: 700;
    letter-spacing: .06em;
    line-height: 1.2;
    text-transform: uppercase;
  }

  body .bo-admin-page .data-card-list tbody td:last-child[data-label]::before {
    display: none;
  }

  body .bo-admin-page .bo-people-cards tbody tr {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-rows: auto;
    min-height: 78px;
    padding: 12px 14px;
  }

  body .bo-admin-page .bo-people-cards tbody td:first-child {
    grid-column: 1;
    grid-row: 1;
    align-self: center;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
  }

  body .bo-admin-page .bo-people-cards tbody td:last-child {
    grid-column: 2;
    grid-row: 1;
    align-self: center;
  }

  body .bo-admin-page .bo-people-cards tbody td[data-label]::before {
    display: none;
  }

  body .bo-admin-page .data-card-list tbody td:nth-child(2) {
    color: #263d35;
    font-size: 14px;
    font-weight: 800;
  }

  body .bo-admin-page .data-card-list tbody td:nth-child(n + 3):not(:last-child) {
    color: #87958f;
    font-size: 12px;
  }

  body .bo-admin-page .bo-finance-cards tbody td:nth-child(2),
  body .bo-admin-page .bo-item-cards tbody td:nth-child(2) {
    color: #87958f;
    font-size: 12px;
    font-weight: 400;
  }

  body .bo-admin-page .bo-finance-cards tbody td:nth-child(3),
  body .bo-admin-page .bo-item-cards tbody td:nth-child(3),
  body .bo-admin-page .bo-model-cards tbody td:first-child {
    color: #17352a;
    font-size: 14px;
    font-weight: 800;
  }

  body .bo-admin-page .bo-guest-cards tbody td:first-child strong {
    color: #17352a;
    font-size: 14px;
    font-weight: 800;
  }

  body .bo-admin-page .bo-finance-cards tbody tr {
    grid-column: auto;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: max-content max-content;
    align-content: start;
    gap: 10px 14px;
    min-height: 0;
    padding: 12px 14px;
  }

  body .bo-admin-page .bo-finance-cards tbody {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  body .bo-admin-page .bo-finance-cards tbody td:first-child {
    grid-column: 1 / -1;
    grid-row: 1;
    align-self: start;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
    padding-right: 28px !important;
  }

  body .bo-admin-page .bo-finance-cards tbody td:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
  }

  body .bo-admin-page .bo-finance-cards tbody td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  body .bo-admin-page .bo-finance-cards tbody td:nth-child(4) {
    grid-column: 3;
    grid-row: 2;
  }

  body .bo-admin-page .bo-finance-cards tbody td:last-child {
    grid-column: 3;
    grid-row: 1;
    align-self: center;
    justify-self: end;
    z-index: 1;
  }

  body .bo-admin-page .bo-finance-cards tbody td[data-label]::before {
    display: none;
  }

  body .bo-admin-page .bo-finance-cards tbody td:nth-child(2),
  body .bo-admin-page .bo-finance-cards tbody td:nth-child(3),
  body .bo-admin-page .bo-finance-cards tbody td:nth-child(4) {
    padding-top: 18px !important;
    border-top: 1px solid #e5eaf1 !important;
  }

  body .bo-admin-page .bo-contract-cards tbody {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  body .bo-admin-page .bo-contract-cards tbody tr {
    grid-column: auto;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: max-content max-content;
    align-content: start;
    gap: 10px 14px;
    min-height: 0;
    padding: 12px 14px;
  }

  body .bo-admin-page .bo-contract-cards tbody td:first-child {
    grid-column: 1 / -1;
    grid-row: 1;
    align-self: start;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
    padding-right: 28px !important;
  }

  body .bo-admin-page .bo-contract-cards tbody td:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
  }

  body .bo-admin-page .bo-contract-cards tbody td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  body .bo-admin-page .bo-contract-cards tbody td:nth-child(4) {
    grid-column: 3;
    grid-row: 2;
  }

  body .bo-admin-page .bo-contract-cards tbody td:last-child {
    grid-column: 3;
    grid-row: 1;
    align-self: center;
    justify-self: end;
    z-index: 1;
  }

  body .bo-admin-page .bo-contract-cards tbody td[data-label]::before {
    display: none;
  }

  body .bo-admin-page .bo-contract-cards tbody td:nth-child(2),
  body .bo-admin-page .bo-contract-cards tbody td:nth-child(3),
  body .bo-admin-page .bo-contract-cards tbody td:nth-child(4) {
    padding-top: 14px !important;
    border-top: 1px solid #e5eaf1 !important;
  }

  body .bo-admin-page .bo-item-cards tbody {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  body .bo-admin-page .bo-item-cards tbody tr {
    grid-column: auto;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: max-content max-content;
    align-content: start;
    gap: 10px 14px;
    min-height: 0;
    padding: 12px 14px;
  }

  body .bo-admin-page .bo-item-cards tbody td:first-child {
    grid-column: 1 / -1;
    grid-row: 1;
    align-self: start;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
    padding-right: 28px !important;
  }

  body .bo-admin-page .bo-item-cards tbody td:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
  }

  body .bo-admin-page .bo-item-cards tbody td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  body .bo-admin-page .bo-item-cards tbody td:nth-child(4) {
    grid-column: 3;
    grid-row: 2;
  }

  body .bo-admin-page .bo-item-cards tbody td:last-child {
    grid-column: 3;
    grid-row: 1;
    align-self: center;
    justify-self: end;
    z-index: 1;
  }

  body .bo-admin-page .bo-item-cards tbody td[data-label]::before {
    display: none;
  }

  body .bo-admin-page .bo-item-cards tbody td:nth-child(2),
  body .bo-admin-page .bo-item-cards tbody td:nth-child(3),
  body .bo-admin-page .bo-item-cards tbody td:nth-child(4) {
    padding-top: 14px !important;
    border-top: 1px solid #e5eaf1 !important;
  }

  body .bo-admin-page .bo-model-cards tbody {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  body .bo-admin-page .bo-model-cards tbody tr {
    grid-column: auto;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: max-content max-content;
    align-content: start;
    gap: 10px 14px;
    min-height: 0;
    padding: 12px 14px;
  }

  body .bo-admin-page .bo-model-cards tbody td:first-child {
    grid-column: 1 / -1;
    grid-row: 1;
    align-self: start;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
    padding-right: 28px !important;
  }

  body .bo-admin-page .bo-model-cards tbody td:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
  }

  body .bo-admin-page .bo-model-cards tbody td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  body .bo-admin-page .bo-model-cards tbody td:last-child {
    grid-column: 2;
    grid-row: 1;
    align-self: center;
    justify-self: end;
    z-index: 1;
  }

  body .bo-admin-page .bo-model-cards tbody td[data-label]::before {
    display: none;
  }

  body .bo-admin-page .bo-model-cards tbody td:nth-child(2),
  body .bo-admin-page .bo-model-cards tbody td:nth-child(3) {
    padding-top: 14px !important;
    border-top: 1px solid #e5eaf1 !important;
  }

  body .bo-admin-page .bo-map-cards tbody {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  body .bo-admin-page .bo-map-cards tbody tr {
    grid-column: auto;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: max-content max-content;
    align-content: start;
    gap: 10px 14px;
    min-height: 0;
    padding: 12px 14px;
  }

  body .bo-admin-page .bo-map-cards tbody td:first-child {
    grid-column: 1 / -1;
    grid-row: 1;
    align-self: start;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
    padding-right: 28px !important;
  }

  body .bo-admin-page .bo-map-cards tbody td:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
  }

  body .bo-admin-page .bo-map-cards tbody td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  body .bo-admin-page .bo-map-cards tbody td:nth-child(4) {
    grid-column: 3;
    grid-row: 2;
  }

  body .bo-admin-page .bo-map-cards tbody td:last-child {
    grid-column: 3;
    grid-row: 1;
    align-self: center;
    justify-self: end;
    z-index: 1;
  }

  body .bo-admin-page .bo-map-cards tbody td[data-label]::before {
    display: none;
  }

  body .bo-admin-page .bo-map-cards tbody td:nth-child(2),
  body .bo-admin-page .bo-map-cards tbody td:nth-child(3),
  body .bo-admin-page .bo-map-cards tbody td:nth-child(4) {
    padding-top: 14px !important;
    border-top: 1px solid #e5eaf1 !important;
  }

  body .bo-admin-page .bo-guest-cards tbody {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  body .bo-admin-page .bo-guest-cards tbody tr {
    grid-column: auto;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: max-content max-content max-content;
    align-content: start;
    gap: 10px 14px;
    min-height: 0;
    padding: 12px 14px;
  }

  body .bo-admin-page .bo-guest-cards tbody td:first-child {
    grid-column: 1 / -1;
    grid-row: 1;
    align-self: start;
    color: inherit;
    font-size: inherit;
    font-weight: 400;
    padding-right: 28px !important;
  }

  body .bo-admin-page .bo-guest-cards tbody td:nth-child(2) {
    grid-column: 1;
    grid-row: 2;
  }

  body .bo-admin-page .bo-guest-cards tbody td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
  }

  body .bo-admin-page .bo-guest-cards tbody td:nth-child(4) {
    grid-column: 1 / -1;
    grid-row: 3;
  }

  body .bo-admin-page .bo-guest-cards tbody td:nth-child(5) {
    grid-column: 3;
    grid-row: 2;
  }

  body .bo-admin-page .bo-guest-cards tbody td:last-child {
    grid-column: 3;
    grid-row: 1;
    align-self: center;
    justify-self: end;
    z-index: 1;
  }

  body .bo-admin-page .bo-guest-cards tbody td[data-label]::before {
    display: none;
  }

  body .bo-admin-page .bo-guest-cards tbody td:nth-child(2),
  body .bo-admin-page .bo-guest-cards tbody td:nth-child(3),
  body .bo-admin-page .bo-guest-cards tbody td:nth-child(4),
  body .bo-admin-page .bo-guest-cards tbody td:nth-child(5) {
    padding-top: 14px !important;
    border-top: 1px solid #e5eaf1 !important;
  }

  body .bo-admin-page .data-card-list > div:last-child {
    flex: 0 0 auto;
    min-height: 58px;
    margin-top: 16px;
    border: 0 !important;
    border-radius: 16px;
    background: #f8fbff !important;
    box-shadow: none;
  }

  @media (max-width: 1160px) {
    body .bo-admin-page .bo-dashboard-kpis {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    body .bo-admin-page .data-card-list tbody {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 780px) {
    body .bo-admin-page.bo-admin-page {
      display: block !important;
      overflow: hidden;
    }

    body .bo-admin-page .bo-admin-sidebar-slot {
      position: fixed;
      inset: 0 auto 0 0;
      z-index: 20;
      width: min(288px, calc(100vw - 28px)) !important;
      box-shadow: 18px 0 40px rgba(4, 19, 44, .25);
    }

    body .bo-admin-page .bo-admin-sidebar-slot[data-isopen='false'] {
      width: 0 !important;
      box-shadow: none;
    }

    body .bo-admin-page .bo-admin-content {
      width: 100%;
      height: 100dvh !important;
    }

    body .bo-admin-page .bo-admin-header-slot {
      min-height: 82px !important;
      height: 82px;
      padding: 12px 12px 0;
    }

    body .bo-admin-page .bo-admin-header-card {
      height: 66px;
      min-height: 66px;
      padding: 0 14px;
      border-radius: 20px;
    }

    body .bo-admin-page .bo-admin-main {
      padding: 14px 12px 18px;
    }

    body .bo-admin-page .bo-page-toolbar {
      align-items: stretch;
      flex-direction: column-reverse;
      gap: 10px;
      padding: 0 0 14px;
    }

    body .bo-admin-page .bo-page-toolbar input,
    body .bo-admin-page .bo-page-toolbar button {
      width: 100%;
      max-width: none;
    }

    body .bo-admin-page .data-card-list {
      padding: 14px 14px 0;
      border-radius: 20px;
    }

    body .bo-admin-page .data-card-list tbody {
      grid-template-columns: minmax(0, 1fr);
    }

    body .bo-admin-page .bo-people-cards tbody tr {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-rows: none;
    }

    body .bo-admin-page .bo-people-cards tbody td:first-child {
      grid-column: auto;
      grid-row: auto;
    }

    body .bo-admin-page .bo-people-cards tbody td:last-child {
      grid-column: 2;
      grid-row: 1;
    }

    body .bo-admin-page .bo-finance-cards tbody tr {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-rows: none;
    }

    body .bo-admin-page .bo-finance-cards tbody td:nth-child(1),
    body .bo-admin-page .bo-finance-cards tbody td:nth-child(2),
    body .bo-admin-page .bo-finance-cards tbody td:nth-child(3),
    body .bo-admin-page .bo-finance-cards tbody td:nth-child(4),
    body .bo-admin-page .bo-finance-cards tbody td:nth-child(5),
    body .bo-admin-page .bo-finance-cards tbody td:nth-child(6),
    body .bo-admin-page .bo-finance-cards tbody td:nth-child(7) {
      grid-column: auto;
      grid-row: auto;
    }

    body .bo-admin-page .bo-finance-cards tbody td:last-child {
      grid-column: 2;
      grid-row: 1;
    }

    body .bo-admin-page .bo-contract-cards tbody tr {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-rows: none;
    }

    body .bo-admin-page .bo-contract-cards tbody td:nth-child(1),
    body .bo-admin-page .bo-contract-cards tbody td:nth-child(2),
    body .bo-admin-page .bo-contract-cards tbody td:nth-child(3),
    body .bo-admin-page .bo-contract-cards tbody td:nth-child(4) {
      grid-column: auto;
      grid-row: auto;
    }

    body .bo-admin-page .bo-contract-cards tbody td:last-child {
      grid-column: 2;
      grid-row: 1;
    }

    body .bo-admin-page .bo-item-cards tbody tr {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-rows: none;
    }

    body .bo-admin-page .bo-item-cards tbody td:nth-child(1),
    body .bo-admin-page .bo-item-cards tbody td:nth-child(2),
    body .bo-admin-page .bo-item-cards tbody td:nth-child(3),
    body .bo-admin-page .bo-item-cards tbody td:nth-child(4) {
      grid-column: auto;
      grid-row: auto;
    }

    body .bo-admin-page .bo-item-cards tbody td:last-child {
      grid-column: 2;
      grid-row: 1;
    }

    body .bo-admin-page .bo-model-cards tbody tr {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-rows: none;
    }

    body .bo-admin-page .bo-model-cards tbody td:nth-child(1),
    body .bo-admin-page .bo-model-cards tbody td:nth-child(2),
    body .bo-admin-page .bo-model-cards tbody td:nth-child(3) {
      grid-column: auto;
      grid-row: auto;
    }

    body .bo-admin-page .bo-model-cards tbody td:last-child {
      grid-column: 2;
      grid-row: 1;
    }

    body .bo-admin-page .bo-map-cards tbody tr {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-rows: none;
    }

    body .bo-admin-page .bo-map-cards tbody td:nth-child(1),
    body .bo-admin-page .bo-map-cards tbody td:nth-child(2),
    body .bo-admin-page .bo-map-cards tbody td:nth-child(3),
    body .bo-admin-page .bo-map-cards tbody td:nth-child(4) {
      grid-column: auto;
      grid-row: auto;
    }

    body .bo-admin-page .bo-map-cards tbody td:last-child {
      grid-column: 2;
      grid-row: 1;
    }

    body .bo-admin-page .bo-guest-cards tbody tr {
      grid-template-columns: minmax(0, 1fr) auto;
      grid-template-rows: none;
    }

    body .bo-admin-page .bo-guest-cards tbody td:nth-child(1),
    body .bo-admin-page .bo-guest-cards tbody td:nth-child(2),
    body .bo-admin-page .bo-guest-cards tbody td:nth-child(3),
    body .bo-admin-page .bo-guest-cards tbody td:nth-child(4),
    body .bo-admin-page .bo-guest-cards tbody td:nth-child(5) {
      grid-column: auto;
      grid-row: auto;
    }

    body .bo-admin-page .bo-guest-cards tbody td:last-child {
      grid-column: 2;
      grid-row: 1;
    }

    body .bo-admin-page .bo-dashboard-kpis,
    body .bo-admin-page .bo-dashboard-charts {
      grid-template-columns: minmax(0, 1fr);
    }
  }
`;
